

//interceptar as requisicoes axios, incluindo o bearer token do keycloak no header 
export default function setup(keycloak, axiosInstances) {

    // axiosBuffet.interceptors.request.use(function (config) {
    //     const token = keycloak.token;
    //     //console.log('interceptor token:' + token);
    //     if (token) {
    //         config.headers.Authorization = `Bearer ${token}`;
    //     }
    //     return config;
    // }, function (err) {
    //     return Promise.reject(err);
    // });

    // varre as instancias axios e ajusta o interceptador
    axiosInstances.forEach(instance => {
        instance.interceptors.request.use(
            (config) => {
                const token = keycloak.token;
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (err) => Promise.reject(err)
        );
    });

    // Response interceptor for API calls
    // axiosBuffet.interceptors.response.use((response) => {
    //     return response;
    // }, function (error) {
    //     // Do something with response error
    //     if (error.response.status === 401) {
    //         console.log('Sessão expirada' - "Necessário realizar o login novamente!");
    //         keycloak.logout();
    //     }
    //     return Promise.reject(error.response);
    // });

    axiosInstances.forEach(instance => {
        instance.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    console.log('Sessão expirada - Necessário realizar o login novamente!');
                    keycloak.logout();
                }
                return Promise.reject(error);
            }
        );
    });
}